import { render, staticRenderFns } from "./SelfSignup.vue?vue&type=template&id=4f282ff0&"
import script from "./SelfSignup.vue?vue&type=script&lang=js&"
export * from "./SelfSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports